// extracted by mini-css-extract-plugin
export default {"text":"DynamicTexts_text__uwIY0","fadeIn":"DynamicTexts_fadeIn__64FmZ"};